'use strict'

import master from 'Modules/master'
import carousel from 'Modules/carousel'

master.process()
carousel.activerSliderPepites()
